import CONSTANTS from "../../app-consts/appConstants";

export const getMemberNotFoundMessage = (isAllstatePartner: boolean) =>
  isAllstatePartner ? CONSTANTS.MEMBER_NOT_FOUND_MESSAGE_ALLSTATE_PARTNER : CONSTANTS.MEMBER_NOT_FOUND_MESSAGE;
